import { createStore } from 'vuex'

import modules from './modules'

const store = createStore({
  modules,
  // Enable strict mode in development to get a warning
  // when mutating state outside of a mutation.
  // https://vuex.vuejs.org/guide/strict.html
  strict: process.env.NODE_ENV !== 'production',
})

// Automatically dispatch init for modules that have it
Object.keys(modules).forEach((moduleName) => {
  if (modules[moduleName].actions?.init) {
    store.dispatch(`${moduleName}/init`);
  }
});

export default store

